import {
  User,
  Branch,
  Customer,
  Report,
  ScheduledReport,
  Product,
  UnifiedOrder,
} from '../types'

export const MOCK_USERS: User[] = [
  {
    id: '1',
    name: 'Admin User',
    username: 'admin',
    email: 'admin@waseel.com',
    role: 'ADMIN',
    status: 'ACTIVE',
    magentoSyncStatus: 'SYNCED',
    lastLogin: '2026-06-28 10:00 AM',
    createdAt: '2025-01-01',
  },
  {
    id: '2',
    name: 'Branch Manager',
    username: 'branch_mgr',
    email: 'manager@pharmacy.com',
    role: 'BRANCH',
    status: 'ACTIVE',
    magentoSyncStatus: 'PENDING',
    lastLogin: '2026-06-27 04:30 PM',
    createdAt: '2025-02-15',
  },
]

export const MOCK_BRANCHES: Branch[] = [
  {
    id: 'br-1',
    name: 'Main Pharmacy - Riyadh',
    code: 'PH-RYD-001',
    city: 'Riyadh',
    address: 'Olaya St, Riyadh',
    status: 'ACTIVE',
    email: 'riyadh@pharmacy.com',
  },
  {
    id: 'br-2',
    name: 'Jeddah Branch',
    code: 'PH-JED-002',
    city: 'Jeddah',
    address: 'Tahlia St, Jeddah',
    status: 'ACTIVE',
    email: 'jeddah@pharmacy.com',
  },
]

export const MOCK_CUSTOMERS: Customer[] = [
  {
    id: 'cust-1',
    name: 'Ahmed Mansour',
    email: 'ahmed@example.com',
    phone: '+966 50 123 4567',
    status: 'ACTIVE',
    createdAt: '2025-03-10',
    totalOrders: 12,
    lastOrderDate: '2026-06-25',
  },
  {
    id: 'cust-2',
    name: 'Sara Al-Otaibi',
    email: 'sara@example.com',
    phone: '+966 55 987 6543',
    status: 'ACTIVE',
    createdAt: '2025-05-20',
    totalOrders: 5,
    lastOrderDate: '2026-06-20',
  },
]

export const MOCK_REPORTS: Report[] = [
  {
    id: 'rep-1',
    name: 'Prescription Status Report',
    type: 'PRESCRIPTION_STATUS',
    description: 'Summary of all prescriptions and their current status.',
    icon: 'FileText',
    totalRuns: 156,
    lastGenerated: '2026-06-27',
  },
  {
    id: 'rep-2',
    name: 'SLA Performance',
    type: 'SLA_REPORT',
    description: 'Analysis of response times and fulfillment SLAs.',
    icon: 'Clock',
    totalRuns: 89,
    lastGenerated: '2026-06-28',
  },
]

export const MOCK_SCHEDULED_REPORTS: ScheduledReport[] = [
  {
    id: 'sch-1',
    reportType: 'SLA_REPORT',
    reportName: 'Weekly SLA Performance',
    frequency: 'WEEKLY',
    format: 'XLSX',
    filters: {},
    recipients: ['admin@waseel.com'],
    nextRun: '2026-07-05',
    status: 'ACTIVE',
    createdAt: '2026-01-10',
    createdBy: 'Admin',
  },
]

export const MOCK_PRODUCTS: Product[] = [
  {
    id: 'prod-1',
    nameEn: 'Panadol 500mg',
    nameAr: 'بنادول 500 ملجم',
    sku: 'SKU-PAN-500',
    genericCode: 'GEN-001',
    tradeCode: 'TRD-001',
    branchOverrides: {
      'br-1': { stock: 150 },
      'br-2': { stock: 0 },
    },
  },
  {
    id: 'prod-2',
    nameEn: 'Amoxil 250mg',
    nameAr: 'أموكسيل 250 ملجم',
    sku: 'SKU-AMX-250',
    genericCode: 'GEN-002',
    tradeCode: 'TRD-002',
    branchOverrides: {
      'br-1': { stock: 5 },
      'br-2': { stock: 20 },
    },
  },
  {
    id: 'prod-3',
    nameEn: 'Brufen 400mg',
    nameAr: 'بروفين 400 ملجم',
    sku: 'SKU-BRF-400',
    genericCode: 'GEN-003',
    tradeCode: 'TRD-003',
    branchOverrides: {
      'br-1': { stock: 0 },
      'br-2': { stock: 2 },
    },
  },
]

export const mockUnifiedOrders: UnifiedOrder[] = [
  {
    id: 'ord-1',
    orderId: 'REF-2026-001',
    customer: {
      name: 'Ahmed Mansour',
      phone: '+966 50 123 4567',
    },
    branch: 'Main Pharmacy - Riyadh',
    status: 'pending',
    items: [{ sku: 'SKU-PAN-500', name: 'Panadol 500mg', quantity: 2 }],
    receivedAt: new Date(Date.now() - 1000 * 60 * 5).toISOString(), // 5 mins ago
    isPickup: false,
    erxReference: 'ERX-998877',
  },
  {
    id: 'ord-2',
    orderId: 'REF-2026-002',
    customer: {
      name: 'Sara Al-Otaibi',
      phone: '+966 55 987 6543',
    },
    branch: 'Jeddah Branch',
    status: 'authorization_requested',
    items: [{ sku: 'SKU-AMX-250', name: 'Amoxil 250mg', quantity: 1 }],
    receivedAt: new Date(Date.now() - 1000 * 60 * 12).toISOString(), // 12 mins ago
    isPickup: true,
    erxReference: 'ERX-112233',
  },
  {
    id: 'ord-3',
    orderId: 'REF-2026-003',
    customer: {
      name: 'Khalid Abdullah',
      phone: '+966 50 111 2222',
    },
    branch: 'Main Pharmacy - Riyadh',
    status: 'dispensed',
    items: [{ sku: 'SKU-BRF-400', name: 'Brufen 400mg', quantity: 1 }],
    receivedAt: new Date(Date.now() - 1000 * 60 * 45).toISOString(), // 45 mins ago
    isPickup: false,
    erxReference: 'ERX-445566',
  },
]
